import { getDataUrl } from "../utils";
import { GREEN_RGB, BLACK_RGB, CREAM_RGB, GOLD_RGB, PAGE_WIDTH } from "../constants";
import PDF from "..";
import { head, pad } from "lodash";

export const useCreateEsgReport = () => {


    const createEsgReport = async ({ orgName, reportingPeriod, finalPercentage, finalScore, totalPoints }) => {
        const whiteLogo = document.getElementById("white-logo");
        const whiteLogoImg = await getDataUrl(whiteLogo);

        const colorLogo = document.getElementById("logo");
        const colorLogoImg = await getDataUrl(colorLogo);

        const fileName = `${orgName.replaceAll(" ", "_")}_${new Date().toLocaleDateString()}_esg.pdf`;

        let pdf = new PDF({ orgName, reportingPeriod, whiteLogoImg, colorLogoImg });

        /***************PAGE 1**************/

        pdf.setFont("helvetica", "bold");
        let pageNum = 1;
        pdf.yCoord = 5;
        await pdf.addHeader(36, "ESG survey");

        pdf.yCoord += 15;
        pdf.addCenteredText("Score", GREEN_RGB, 36);
        pdf.yCoord += 5;
        pdf.addCenteredText(String(finalPercentage) + "%", GOLD_RGB, 50);
        pdf.yCoord += 5;
        pdf.addCenteredText(
            `The total number of points: ${finalScore}`,
            BLACK_RGB,
            18
        );

        pdf.yCoord += 15;
        await pdf.addCanvas("esg-chart", 0.7);
        await pdf.addFooter(pageNum++);

        /***************PAGE 2**************/

        pdf.addPage();
        pdf.yCoord = 0;


        pdf.autoTable({
            html: "#esg-table",
            margin: { top: 58 },
            tableLineWidth: 0.1,
            headStyles: {
                fillColor: GREEN_RGB,
                textColor: BLACK_RGB,
                padding: 2,
            },

            didDrawPage: async (data) => {
                pdf.addCenteredText("Survey results", GREEN_RGB, 20, false, 50);
                pdf.addHeader(36, "ESG survey");
                pdf.addFooter(pageNum++);
            },
        });

        pdf.save(fileName);


    }

    return { createEsgReport }

}
